export interface Article {
  id: number;
  title: string;
  summary: string;
  content: string;
  category: string;
  imageSeq: string;
  author: string;
  source: string;
  publishedAt: string;
  tags: string[];
  readCount: number;
}

export const articles: Article[] = [
  {
    id: 1,
    title: '2026世界杯预选赛亚洲区：中国队关键战役深度前瞻',
    summary: '随着2026年世界杯预选赛亚洲区赛程进入白热化阶段，中国队即将迎来决定出线命运的关键战役。本文从战术、阵容、对手分析等多维度进行全面解读。',
    content: `<p>随着2026年美加墨世界杯预选赛亚洲区赛程进入白热化阶段，中国男足即将迎来决定出线命运的关键战役。在上一轮比赛中，中国队凭借出色的团队配合以2:1力克对手，展现出了令人振奋的竞技状态。</p><p>本轮比赛，中国队将面对实力强劲的亚洲传统强队。从历史交锋记录来看，双方近五次交手各胜两场，打平一场，实力可谓旗鼓相当。主教练在赛前发布会上表示，球队已经针对对手的战术特点做了充分准备，全队上下士气高涨。</p><p>在阵容方面，中国队核心球员状态正佳。锋线尖刀近期在联赛中连续进球，中场发动机的组织调度能力也得到了一致认可。后防线上，经验丰富的老将与冲劲十足的年轻球员形成了良好互补。值得注意的是，球队在定位球攻防方面有了显著提升，这或将成为比赛的关键突破口。</p><p>从战术层面分析，中国队很可能延续近期行之有效的高位逼抢策略，利用对手后场出球的弱点制造反击机会。同时，两翼快速推进也是球队进攻的重要手段。对手虽然整体实力不俗，但近期防线暴露出了一些漏洞，这给了中国队可乘之机。</p><p>本场比赛的结果将直接影响中国队的小组出线形势。球迷们可以通过开云体育平台获取最新赛程信息和实时比分更新，共同见证这一重要时刻。</p>`,
    category: 'football',
    imageSeq: 'article-football-1',
    author: '体育观察员',
    source: '开云体育编辑部',
    publishedAt: '2026-08-05',
    tags: ['世界杯预选赛', '中国足球', '亚洲区', '赛事前瞻'],
    readCount: 38560,
  },
  {
    id: 2,
    title: 'NBA新赛季前瞻：西部豪强格局大洗牌，湖人王朝能否延续辉煌',
    summary: '2026-2027赛季NBA即将拉开帷幕，经过休赛期的交易与调整，西部联盟格局发生了翻天覆地的变化。湖人、勇士、掘金三足鼎立之势能否延续？',
    content: `<p>随着2026-2027赛季NBA开赛日日益临近，各支球队经过休赛期的交易、选秀与阵容调整，联盟实力版图正在悄然重塑。尤其是西部联盟，竞争激烈程度堪称近十年来之最。</p><p>洛杉矶湖人在上赛季夺得总冠军后，核心阵容基本保持稳定。然而，面对其他球队的针对性补强，卫冕之路绝非坦途。詹姆斯和戴维斯这对黄金组合依然是球队的基石，但年龄和伤病问题是最大的不确定因素。管理层在休赛期重点补强了板凳深度，引进了几位经验丰富的老将和充满活力的年轻球员。</p><p>金州勇士在经历了一个令人失望的赛季后，进行了大刀阔斧的改革。除了库里依旧是球队的绝对核心外，轮换阵容几乎焕然一新。新任主教练带来了全新的战术理念，强调更快的节奏转换和更灵活的空间利用。季前赛的表现令人眼前一亮，球迷们对新赛季充满期待。</p><p>丹佛掘金作为近年来的稳定势力，依靠约基奇的全面统治力继续保持着强劲竞争力。球队在上赛季常规赛取得了西部第一的佳绩，虽然季后赛遗憾止步半决赛，但整体实力依然不容小觑。休赛期球队保留了核心框架，并针对性地补强了外线投射能力。</p><p>此外，菲尼克斯太阳、达拉斯独行侠等球队也通过交易大幅提升了竞争力。可以预见，新赛季西部的季后赛席位争夺将异常惨烈。开云体育将持续为您带来NBA最新赛事资讯、实时比分和深度分析。</p>`,
    category: 'basketball',
    imageSeq: 'article-basketball-1',
    author: '篮球评论员',
    source: '开云体育编辑部',
    publishedAt: '2026-08-06',
    tags: ['NBA', '湖人', '西部联盟', '新赛季前瞻'],
    readCount: 28900,
  },
  {
    id: 3,
    title: '温网男单决赛经典回顾：五盘大战缔造传奇瞬间',
    summary: '温布尔登网球锦标赛男单决赛再次上演史诗级对决，两位顶尖选手历经五盘鏖战，为全球网球迷奉献了一场足以载入史册的经典比赛。',
    content: `<p>温布尔登网球锦标赛——这项拥有百年历史的草地大满贯赛事，再次见证了网坛的辉煌时刻。今年的男单决赛在中央球场上演了一场惊心动魄的五盘大战，让全世界的网球迷为之疯狂。</p><p>卫冕冠军在开局阶段展现出了强大的统治力，凭借精准的发球和犀利的底线进攻，迅速拿下首盘。然而，挑战者并没有被对手的气势所压倒。从第二盘开始，他调整了战术策略，加强了接发球的攻击性，同时在网前制造了更多威胁。第二盘的抢七大战堪称经典，双方你来我往，最终挑战者以微弱优势拿下。</p><p>比赛进入胶着状态后，两位选手的体能和意志力都经受着严峻考验。第三盘和第四盘各胜一局，比赛不可避免地进入了决胜盘。在全场观众的屏息注视下，决胜盘的每一分都充满了悬念和戏剧性。最终，卫冕冠军在关键分上展现出了大心脏，以一记精彩的穿越球锁定胜局。</p><p>这场比赛不仅是一次技术层面的较量，更是心理素质和竞技精神的完美体现。两位选手赛后都表达了对彼此的敬意，这场比赛无疑将成为温网历史上最令人难忘的男单决赛之一。开云体育为您带来网球四大满贯赛事全程报道与专业分析。</p>`,
    category: 'tennis',
    imageSeq: 'article-tennis-1',
    author: '网球观察家',
    source: '开云体育编辑部',
    publishedAt: '2026-07-28',
    tags: ['温网', '网球', '大满贯', '男单决赛'],
    readCount: 21000,
  },
  {
    id: 4,
    title: '英雄联盟S16全球总决赛：LPL战队能否重夺召唤师杯',
    summary: '2026英雄联盟全球总决赛即将打响，LPL赛区四支代表队伍整装待发。经历了S15的失落之后，今年LPL战队厉兵秣马，誓要夺回属于东方赛区的荣耀。',
    content: `<p>2026年英雄联盟全球总决赛（S16）即将拉开帷幕，来自全球各大赛区的顶尖战队将齐聚一堂，争夺那座象征着最高荣誉的召唤师杯。对于LPL赛区而言，今年的目标只有一个——夺冠。</p><p>回顾上赛季S15，LPL战队表现不尽如人意，未能闯入决赛，这在国内电竞圈引发了广泛讨论。然而，失利也带来了反思和改变。在刚刚结束的夏季赛中，各支队伍展现出了全新的面貌。战术体系更加成熟，选手个人能力也在不断提升。</p><p>今年代表LPL出征的四支队伍各具特色。一号种子以稳扎稳打的运营风格著称，擅长在中后期通过团战建立优势；二号种子则以激进的进攻风格闻名，前期节奏极具压迫感；三号种子拥有联赛最强的下路组合；四号种子虽然是新军，但年轻选手的冲劲十足。</p><p>LCK赛区依然是LPL最大的竞争对手。韩国战队在运营层面的细腻程度依旧是世界顶级水平。同时，LEC和LCS赛区的队伍也在不断缩小差距，今年的全球总决赛必将是一场群雄逐鹿的盛会。</p><p>开云体育将为电竞爱好者带来S16全球总决赛的全程直播、实时数据分析和深度赛事报道，一起见证LPL战队的荣耀征程。</p>`,
    category: 'esports',
    imageSeq: 'article-esports-1',
    author: '电竞分析师',
    source: '开云体育编辑部',
    publishedAt: '2026-08-03',
    tags: ['英雄联盟', 'S16', 'LPL', '全球总决赛'],
    readCount: 45200,
  },
  {
    id: 5,
    title: '2026乒乓球世锦赛：中国队包揽五金再创辉煌',
    summary: '在刚刚落幕的2026年世界乒乓球锦标赛上，中国队以无可匹敌的统治力包揽全部五个项目的金牌，再次向世界展示了"乒乓王国"的绝对实力。',
    content: `<p>2026年世界乒乓球锦标赛在热烈的氛围中落下帷幕。中国乒乓球队再次以无可争议的实力，包揽了男单、女单、男双、女双和混双全部五个项目的金牌，延续了国乒在世界乒坛的统治地位。</p><p>男单决赛中，世界排名第一的中国选手展现出了惊人的竞技水平。他在半决赛中经历了一场艰苦的七局大战后，在决赛中反而打出了更加从容的状态。面对同样实力强劲的对手，他凭借着出色的旋转变化和关键分处理能力，以4:1的比分赢得胜利。</p><p>女单方面，中国选手更是一路高歌猛进。新生代球员的崛起令人欣喜，她们在比赛中展现出了超越年龄的成熟和稳定的心理素质。决赛中两位中国选手的内战同样精彩纷呈，为观众带来了一场高水平的对决。</p><p>双打项目同样是中国队的强项。男双组合配合默契，女双组合攻防转换流畅，混双组合则展现出了完美的互补性。三枚双打金牌的获得，充分体现了中国乒乓球队在团队配合方面的深厚底蕴。</p><p>开云体育持续关注中国乒乓球队的动态，为您带来世锦赛、世界杯等重大赛事的全面报道和深度分析。</p>`,
    category: 'comprehensive',
    imageSeq: 'article-comprehensive-1',
    author: '乒乓球评论员',
    source: '开云体育编辑部',
    publishedAt: '2026-07-20',
    tags: ['乒乓球', '世锦赛', '中国队', '五金'],
    readCount: 33000,
  },
  {
    id: 6,
    title: '英超新赛季揭幕战：曼城主场迎战利物浦，巅峰对决一触即发',
    summary: '2026-2027赛季英超联赛即将拉开大幕，揭幕战将在卫冕冠军曼城与劲敌利物浦之间展开。这场火星撞地球般的对决吸引了全球数亿球迷的目光。',
    content: `<p>2026-2027赛季英格兰足球超级联赛的揭幕战，将在伊蒂哈德球场上演一场万众瞩目的巅峰对决——卫冕冠军曼彻斯特城主场迎战红军利物浦。这场比赛的关注度丝毫不亚于任何一场欧冠决赛。</p><p>曼城在上赛季以破纪录的积分夺得英超冠军，瓜迪奥拉的球队展现出了令人窒息的统治力。哈兰德继续保持着恐怖的进球效率，德布劳内的创造力似乎永不枯竭。休赛期球队在保持核心框架的基础上，又引进了两位实力派年轻球员，阵容厚度进一步增强。</p><p>利物浦在上赛季经历了换帅后的调整期，新帅带领球队逐步找回了红军的血性和斗志。萨拉赫依然是球队最锋利的武器，而年轻中场的迅速成长则为球队注入了新的活力。经过一个完整的夏季备战，利物浦的整体状态令人期待。</p><p>从历史交锋来看，两队近年来的对决总是充满戏剧性。无论是曼城精妙的传控足球，还是利物浦高效的反击体系，都代表着当今足坛最顶尖的战术水平。这场比赛不仅是两支球队的较量，更是两种足球哲学的对撞。</p><p>开云体育将为您带来英超联赛新赛季的全程直播与实时数据更新，精彩赛事不容错过。</p>`,
    category: 'football',
    imageSeq: 'article-football-2',
    author: '足球评论家',
    source: '开云体育编辑部',
    publishedAt: '2026-08-07',
    tags: ['英超', '曼城', '利物浦', '揭幕战'],
    readCount: 52000,
  },
  {
    id: 7,
    title: 'CBA夏季转会大盘点：多支球队重磅引援引关注',
    summary: '2026年CBA夏季转会窗口已经关闭，多支球队完成了重磅引援。在限薪政策和新外援政策的影响下，各队的引援策略呈现出新的特点和趋势。',
    content: `<p>随着2026年CBA夏季转会窗口的正式关闭，各队的阵容构建工作已基本完成。在联盟推出新的限薪政策和外援使用规则后，今年的转会市场呈现出了一些与往年不同的有趣特点。</p><p>卫冕冠军在保留冠军班底的同时，精准补强了替补控卫和内线轮换两个位置。两名新援均在夏季联赛中展现出了良好的融入状态，球队整体实力有望再上一层楼。主教练在接受采访时对新赛季充满信心。</p><p>传统强队广东宏远在休赛期进行了较大规模的人员调整。几位老将的离队虽然令人感慨，但年轻球员的崛起让人看到了球队光明未来。尤其是几名从青年队提拔上来的新星，在热身赛中的表现令人眼前一亮。</p><p>值得关注的是，多支中游球队通过精准的引援大幅提升了竞争力。新赛季的季后赛席位争夺可能会比往年更加激烈。外援方面，多名拥有NBA经历的球员加盟CBA，将为联赛带来更高的观赏性。</p><p>开云体育将持续关注CBA新赛季动态，为您带来全面的赛事报道和球员数据追踪。</p>`,
    category: 'basketball',
    imageSeq: 'article-basketball-2',
    author: 'CBA观察员',
    source: '开云体育编辑部',
    publishedAt: '2026-08-01',
    tags: ['CBA', '转会', '中国篮球', '新赛季'],
    readCount: 19600,
  },
  {
    id: 8,
    title: 'F1匈牙利大奖赛：雨战中的策略博弈与王者诞生',
    summary: '2026年F1匈牙利大奖赛在变幻莫测的天气中展开，雨水为比赛增添了巨大的不确定性。最终，一场精彩的策略博弈在亨格罗宁赛道上演。',
    content: `<p>2026年F1匈牙利大奖赛在亨格罗宁赛道精彩落幕。比赛日多变的天气条件为这场速度盛宴增添了额外的戏剧性——时而倾盆大雨，时而阳光普照，车队策略师们经历了本赛季最具挑战性的一次决策考验。</p><p>排位赛中，杆位获得者展现出了在湿滑赛道上的超凡控车能力。然而正赛的发车阶段却发生了戏剧性的一幕：突如其来的阵雨让多位车手措手不及，赛道上的位置发生了剧烈变化。安全车的多次出动进一步压缩了车辆之间的差距。</p><p>轮胎策略成为了决定比赛走向的关键因素。在干湿交替的赛道条件下，何时从雨胎切换到中性胎、再切换到干胎，每一个决策都牵动着千万车迷的心。最终，经验丰富的卫冕冠军凭借精准的策略判断和稳健的驾驶表现，在这场混乱的雨战中脱颖而出，赢得了本赛季的第四座分站冠军奖杯。</p><p>领奖台上，三位车手都对比赛策略团队表示了感谢。这场比赛再次证明了F1不仅仅是一场关于速度的竞技，更是一场关于智慧、勇气和团队协作的综合较量。开云体育为您带来F1全年赛程的追踪报道和精彩瞬间回放。</p>`,
    category: 'comprehensive',
    imageSeq: 'article-comprehensive-2',
    author: '赛车评论员',
    source: '开云体育编辑部',
    publishedAt: '2026-07-31',
    tags: ['F1', '匈牙利大奖赛', '赛车', '雨战'],
    readCount: 15800,
  },
  {
    id: 9,
    title: 'DOTA2国际邀请赛TI16：中国军团厉兵秣马誓夺不朽盾',
    summary: '2026年DOTA2国际邀请赛TI16即将开启。三支中国战队获得直邀资格，他们将向象征着DOTA2最高荣誉的不朽盾发起冲击。',
    content: `<p>2026年DOTA2国际邀请赛（TI16）的脚步声越来越近。作为电竞赛事中奖金最高、影响力最大的盛会之一，每一届TI都牵动着全球数千万DOTA2玩家的心。今年，三支中国战队凭借全年出色的表现获得了直邀资格。</p><p>头号种子战队在今年的DPC赛季中表现抢眼，先后斩获两个Major冠军，以赛区第一的身份直邀TI。战队核心选手状态火热，英雄池深厚，是本届TI夺冠热门之一。队伍在最近的训练赛中状态正佳，新开发的几套战术体系颇具威胁。</p><p>二号种子同样不容小觑。作为一支充满韧性的队伍，他们在逆境中屡屡创造奇迹。队伍的团队配合已经达到了极高的默契度，中后期团战能力堪称世界顶级。TI的舞台上，这支队伍完全有能力走得更远。</p><p>三号种子虽然整体实力稍逊，但拥有多位天赋异禀的年轻选手。他们的战术风格激进且富有创造力，经常能够打出出人意料的精彩操作。对于这支年轻队伍来说，TI的舞台将是他们展示自我的最佳机会。</p><p>开云体育将为广大DOTA2爱好者带来TI16的全程赛事直播、专业解说的赛后分析和实时数据统计。</p>`,
    category: 'esports',
    imageSeq: 'article-esports-2',
    author: 'DOTA2分析师',
    source: '开云体育编辑部',
    publishedAt: '2026-08-04',
    tags: ['DOTA2', 'TI16', '国际邀请赛', '中国战队'],
    readCount: 27500,
  },
  {
    id: 10,
    title: '法网女单：新科冠军的崛起之路与未来展望',
    summary: '2026年法国网球公开赛女单决赛落下帷幕，一位年仅21岁的新星在罗兰·加洛斯红土场上书写了属于自己的童话故事。她的崛起意味着女子网坛新时代的到来。',
    content: `<p>在2026年法国网球公开赛女单决赛中，一位年仅21岁的新星以令人惊叹的表现击败了多位种子选手，在罗兰·加洛斯的红土场上捧起了她职业生涯的首座大满贯冠军奖杯。这位年轻选手的崛起，标志着女子网坛新老交替的加速。</p><p>回顾她的夺冠之路，堪称一部励志大片。首轮比赛她就遭遇了种子选手，以三盘苦战晋级；第四轮面对前世界第一，她在先失一盘的情况下完成逆转；半决赛更是打出了职业生涯最高水准，以两个6:2轻松淘汰二号种子。决赛中，面对经验丰富的老将，她展现出了超越年龄的沉稳和智慧。</p><p>技术层面，她的打法融合了力量与技巧。强劲的正手是她的主要得分武器，而灵活的脚步移动让她能够覆盖球场的每一个角落。更令人印象深刻的是她在关键分上的冷静处理——决赛中面临多个破发点时，她总能以精准的发球化险为夷。</p><p>这位新科冠军的崛起，为女子网坛注入了新鲜血液。随着小威廉姆斯等传奇选手的退役，网坛需要新的明星，而她无疑具备了成为下一个传奇的所有条件。开云体育将继续关注她的成长历程。</p>`,
    category: 'tennis',
    imageSeq: 'article-tennis-2',
    author: '网球评论员',
    source: '开云体育编辑部',
    publishedAt: '2026-07-15',
    tags: ['法网', '女单', '网球', '大满贯'],
    readCount: 18600,
  },
  {
    id: 11,
    title: '欧冠小组赛抽签揭晓：死亡之组再现，豪门命运几何',
    summary: '2026-2027赛季欧洲冠军联赛小组赛抽签仪式在摩纳哥举行。多支豪门球队齐聚"死亡之组"，新赛季欧冠的精彩程度值得期待。',
    content: `<p>2026-2027赛季欧洲冠军联赛小组赛抽签仪式在摩纳哥蒙特卡洛如期举行。作为世界足坛最具影响力的俱乐部赛事，每一年的抽签结果都牵动着亿万球迷的心。今年的抽签再次制造了多个引人关注的"死亡之组"。</p><p>其中最引人注目的是C组的对决——上赛季的欧冠冠军、西甲霸主、英超劲旅和意甲黑马齐聚一组。这样一个小组的每一场比赛都将是顶级对决。对于四支球队来说，小组出线都绝非易事，每一分都至关重要。球迷们已经开始热议哪两支球队能够最终从这一"地狱之组"中突围。</p><p>相比之下，卫冕冠军所在的A组则相对温和。但主教练在抽签后接受采访时强调，欧冠赛场上没有轻松的比赛，球队必须以最大的专注度对待每一个对手。尤其是在客场比赛中，任何一点松懈都可能导致失分。</p><p>对于多支首次晋级欧冠正赛的球队来说，这无疑是实现梦想的舞台。他们或许在实力上不如传统豪门，但黑马的故事在欧冠历史上屡见不鲜。开云体育将为您全程追踪欧冠新赛季的精彩赛程和实时比分。</p>`,
    category: 'football',
    imageSeq: 'article-football-3',
    author: '欧冠观察员',
    source: '开云体育编辑部',
    publishedAt: '2026-08-02',
    tags: ['欧冠', '小组赛', '抽签', '死亡之组'],
    readCount: 41000,
  },
  {
    id: 12,
    title: '中国游泳队出征世锦赛：年轻阵容剑指多项金牌',
    summary: '中国游泳队派出新老结合的阵容出征2026年布达佩斯世界游泳锦标赛。在东京奥运会取得突破之后，中国游泳健儿们期待在世锦赛上再创佳绩。',
    content: `<p>中国游泳队已经抵达匈牙利布达佩斯，正式开启2026年世界游泳锦标赛的征程。经过数月的封闭集训，这支新老结合的队伍在体能、技术和心理层面都达到了最佳状态，剑指多个项目的金牌。</p><p>在男子项目方面，中国队在自由泳和蝶泳项目上拥有世界级的竞争力。几位核心选手在今年的全国冠军赛上刷新了多项个人最好成绩，状态正处于上升期。尤其是男子200米蝶泳项目，中国选手具备冲击金牌的绝对实力。</p><p>女子项目同样看点十足。女子4×200米自由泳接力队是卫冕冠军，虽然阵容进行了一定程度的调整，但整体实力依然处于世界领先水平。此外，女子混合泳项目也具备夺牌实力，小将们在近期的训练中展现出了令人惊喜的进步。</p><p>总教练在出发前表示，本次世锦赛的目标是在巩固传统优势项目的基础上，争取在更多项目上实现突破。年轻选手的成长速度超出了教练组的预期，这也为中国游泳的未来增添了更多可能性。开云体育将持续关注中国游泳队的世锦赛征程。</p>`,
    category: 'comprehensive',
    imageSeq: 'article-comprehensive-3',
    author: '游泳专项记者',
    source: '开云体育编辑部',
    publishedAt: '2026-07-25',
    tags: ['游泳', '世锦赛', '中国队', '布达佩斯'],
    readCount: 22300,
  },
];